import React from 'react';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import CurrencyForm from './ProjectCurrencyForm';
import ProjectNameForm from './ProjectNameForm';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import ProjectDomainForm from './ProjectDomainForm';

export interface GeneralSettingsPageProps {
  project: ProjectGq;
  setNameDirty: (dirty: boolean) => void;
  setNameSave: (saveFunction: () => Promise<unknown>) => void;
  setCurrencyDirty: (dirty: boolean) => void;
  setCurrencySave: (saveFunction: () => Promise<unknown>) => void;
  setDomainDirty: (dirty: boolean) => void;
  setDomainSave: (saveFunction: () => Promise<unknown>) => void;
  reload: () => Promise<unknown>;
}

const GeneralSettingsPage: React.FC<GeneralSettingsPageProps> = ({
  project,
  setNameDirty,
  setNameSave,
  setCurrencyDirty,
  setCurrencySave,
  setDomainDirty,
  setDomainSave,
  reload,
}) => {
  return (
    <div className="flex flex-col gap-8">
      <div>
        <VoxelText variant="title2">General</VoxelText>
      </div>
      <span id='name'>
        <ProjectNameForm
          project={project}
          setDirty={setNameDirty}
          setSave={setNameSave}
          reload={reload}
        />
      </span>
      <span id='domain'>
        <ProjectDomainForm
          project={project}
          setDirty={setDomainDirty}
          setSave={setDomainSave}
          reload={reload}
        />
      </span>
      <CurrencyForm
        project={project}
        setDirty={setCurrencyDirty}
        setSave={setCurrencySave}
        reload={reload}
      />
    </div>
  );
};

export default GeneralSettingsPage;
